import React from 'react';

const PersonRedIconHeader = ({ size = 20, fill = '#CE181E' }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.99998 9.74355C9.19791 9.74355 8.51128 9.45797 7.9401 8.8868C7.36892 8.31562 7.08333 7.62899 7.08333 6.82692C7.08333 6.02484 7.36892 5.33822 7.9401 4.76705C8.51128 4.19587 9.19791 3.91028 9.99998 3.91028C10.802 3.91028 11.4887 4.19587 12.0599 4.76705C12.631 5.33822 12.9166 6.02484 12.9166 6.82692C12.9166 7.62899 12.631 8.31562 12.0599 8.8868C11.4887 9.45797 10.802 9.74355 9.99998 9.74355ZM3.75 16.0897V14.2372C3.75 13.829 3.86085 13.4511 4.08254 13.1034C4.30422 12.7556 4.60042 12.4883 4.97115 12.3013C5.79487 11.8974 6.6258 11.5945 7.46394 11.3926C8.30208 11.1907 9.14742 11.0898 9.99998 11.0898C10.8525 11.0898 11.6979 11.1907 12.536 11.3926C13.3742 11.5945 14.2051 11.8974 15.0288 12.3013C15.3995 12.4883 15.6957 12.7556 15.9174 13.1034C16.1391 13.4511 16.25 13.829 16.25 14.2372V16.0897H3.75Z"
        fill={fill}
      />
    </svg>
  );
};

export default PersonRedIconHeader;
